import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TableMaintenance from "./components/table-maintenances/TableMaintenance";

export function MaintenanceRegisterPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <TableMaintenance />
      </Dashboard>
      <Toast />
    </ToastProvider>
  );
}
